import { DispatchBanner, Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Phone } from "lucide-react";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen pb-28 md:pb-0 bg-white font-sans text-gray-900">
      <DispatchBanner />
      <Navbar />

      <main className="flex-grow">{children}</main>

      {/* Mobile Sticky Footer */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-salt-dark text-white p-4 z-50 flex justify-between items-center shadow-[0_-4px_10px_rgba(0,0,0,0.2)]">
        <div className="flex flex-col">
          <span className="text-[10px] font-black uppercase tracking-widest text-salt-orange">
            24/7 Dispatch
          </span>
          <a
            href="tel:8884910911"
            className="text-lg font-black tracking-tight"
          >
            (888) 491-0911
          </a>
        </div>
        <a
          href="tel:8884910911"
          className="bg-salt-orange text-white px-6 py-3 rounded font-black uppercase tracking-widest text-[11px] active:bg-orange-600 transition-colors shadow-lg"
        >
          Call Now
        </a>
      </div>

      {/* Floating Action Button (Desktop) */}
      <div className="hidden md:block">
        <div className="fixed bottom-12 left-6 z-[100]">
          <a
            href="tel:8884910911"
            aria-label="Call 24/7 Dispatch"
            className="flex items-center justify-center bg-salt-dark text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all group relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-tr from-salt-orange/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <Phone className="w-6 h-6 relative z-10 fill-current" />
            <span className="absolute -top-1 -right-1 flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-salt-orange opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-salt-orange"></span>
            </span>
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
}
